<template>
  <v-container no-gutters>
    <v-row
        no-gutters
        justify="center"
    >
      <v-col
          v-for="(placement, index) in winInformation.placements"
          :key="index"
          :cols="placement.position == 1 ? 12 : 6"
          class="text-center"
          no-gutters
      >
        <template v-if="placement.position == 1">
            <v-icon :class="trophyClassesFor(placement)" size="100">mdi-trophy</v-icon>
            <v-row class="text-center justify-center">
              <v-col cols="auto">
                <user-widget :display-icon="false" :user="placement.player" :showDefaultActions="[]" playerAvatarColSelfAlign="start" />
              </v-col>
            </v-row>
        </template>
        <template v-else>
            <v-row class="justify-center">
              <v-col cols="auto" :align-self="'start'" data-test-id="x">
                <v-icon :class="trophyClassesFor(placement)" size="50">mdi-trophy</v-icon>
                <user-widget :display-icon="false" :user="placement.player" :showDefaultActions="[]" playerAvatarColSelfAlign="start">
                  &nbsp;
                </user-widget>
              </v-col>
            </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'WinInformation',
  components: {},
  props: {
    winInformation: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {}
  },
  methods: {
    trophyClassesFor: function (placement) {
      if (placement.position == 1) {
        return 'gold green-glow'
      } else if (placement.position == 2) {
        return 'silver'
      } else if (placement.position == 3) {
        return 'bronze'
      }
      return ''
    }
  }
}
</script>

<style scoped>
.gold {
  color: #ffd700;
  font-size: 400%;
}

.silver {
  color: #c0c0c0;
  font-size: 200%;
}

.bronze {
  color: #cd7f32;
  font-size: 200%;
}
</style>
